import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox, FormControlLabel } from '@material-ui/core';
import { Button, colors } from 'kangarootime-ui';
import RoomFilter from '../../../../components/RoomFilter';
import './ViewControls.css';

const ViewControls = ({ toggleSelectAll, rooms, selectedRoom, approvePhotos, rejectPhotos, buttonsDisabled, filterPendingPhotosByRoomId }) => (
  <Grid container className='photoApprovalViewControlsContainer'>
    <Grid item>
      <RoomFilter
        rooms={rooms}
        selected={selectedRoom}
        onSelect={event => filterPendingPhotosByRoomId(event.target.value)}
      />
    </Grid>
    <Grid item xs={12} sm className='flex-1' style={{ justifyContent: 'flex-end', flexDirection: 'row', marginTop: 8 }}>
      <FormControlLabel
        label='Select All'
        control={
          <Checkbox
            onChange={toggleSelectAll}
            style={{ color: colors.brand_3 }}
          />
        }
      />
      <div className='flex-rows'>
        <Button type='secondary' onClick={approvePhotos} disabled={buttonsDisabled}>
          Approve Selected
        </Button>
        <Button type='danger' onClick={rejectPhotos} disabled={buttonsDisabled}>
          Reject Selected
        </Button>
      </div>
    </Grid>
  </Grid>
);

ViewControls.propTypes = {
  toggleSelectAll: PropTypes.func,
  rooms: PropTypes.array,
  selectedRoom: PropTypes.number,
  approvePhotos: PropTypes.func,
  rejectPhotos: PropTypes.func,
  buttonsDisabled: PropTypes.bool,
  filterPendingPhotosByRoomId: PropTypes.func
};

export default ViewControls;
